import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {LeadValue} from 'shells/lead/value/lead-value';
import {SelectLeadStatus} from 'shells/select-lead-status/select-lead-status';
import type {Tag} from 'shells/tags-editor/tags-editor';

import type {GetLead_lead as Lead, SessionUser} from 'nutshell-graphql-types';

import {AssigneeButton} from '../deprecated/header/buttons/assignee-button';
import {LeadActionMenu} from '../deprecated/header/lead-action-menu';
import {LeadIcon} from '../deprecated/header/lead-icon';
import {LeadNameContainer} from '../deprecated/header/lead-name-container';
import {LeadTagsEditor} from '../shared/components/lead-tags-editor';

import {useUpdateLeadPriority} from './graphql/hooks/use-update-lead-priority';
import {useUpdateLeadWatched} from './graphql/hooks/use-update-lead-watched';
import {HeaderIconToggles} from './header-icon-toggles';

import styles from './header.module.css';

type Props = {
    lead: Lead;
    user: SessionUser | null | undefined;
    onUpdateLeadName: (arg1: string) => Promise<any>;
    onUpdateTags: (arg1: Tag[]) => void;
    fetchTags: (arg1: string) => Promise<any>;
};

export function HeaderActionBar(props: Props) {
    const {updateLeadWatched} = useUpdateLeadWatched();
    const {updateLeadPriority} = useUpdateLeadPriority();

    const handleHotToggle = React.useCallback(() => {
        updateLeadPriority({
            input: {id: props.lead.id, priority: !props.lead.isHot ? 'HOT' : 'NORMAL'},
            lead: props.lead,
        });
    }, [updateLeadPriority, props.lead]);

    const handleWatchingToggle = React.useCallback(() => {
        updateLeadWatched({
            input: {id: props.lead.id, shouldWatch: !props.lead.isCurrentUserWatching},
            lead: props.lead,
        });
    }, [updateLeadWatched, props.lead]);

    return (
        <Stack isHorizontal={true} isFullWidth={true} spacing={16}>
            <LeadIcon
                id={props.lead.id}
                status={props.lead.status}
                number={props.lead.number}
                avatarUrl={props.lead.avatarUrl}
            />
            <div className={styles['header-action-bar-container']}>
                <Stack isHorizontal={true} spacing={16} justifyContent='space-between'>
                    <div className={styles['name-container']}>
                        <LeadNameContainer
                            lead={props.lead}
                            onUpdateLeadName={props.onUpdateLeadName}
                        />
                    </div>
                    <Stack isHorizontal={true} spacing={8} alignItems='start'>
                        <LeadValue
                            valueFormatted={props.lead.value && props.lead.value.formatted}
                        />
                        <div className={styles['assignee-button-container']}>
                            <AssigneeButton lead={props.lead} showTooltip={true} />
                        </div>
                        <SelectLeadStatus
                            leadId={props.lead.id}
                            value={props.lead.status}
                            onChange={() => {}}
                            includeControlIcon={true}
                        />
                        <HeaderIconToggles
                            lead={props.lead}
                            userCanAccessSetup={
                                props.user ? props.user.permissions.canAccessSetup : false
                            }
                            onHotToggle={handleHotToggle}
                            onWatchingToggle={handleWatchingToggle}
                        />
                        <div className='mt-2'>
                            <LeadActionMenu lead={props.lead} isSmall={true} />
                        </div>
                    </Stack>
                </Stack>
                {!NutClientConfig.hasCoreEntityFullHeightSidebarFF && (
                    <LeadTagsEditor
                        lead={props.lead}
                        user={props.user}
                        fetchTags={props.fetchTags}
                    />
                )}
            </div>
        </Stack>
    );
}
